import React, {useState, useEffect} from 'react';
import styles from './styles.module.css';

export const BtBurger = ({onClick, isOpen}) => {
  const [_open, toggleOpen] = useState(isOpen);
  useEffect(() => toggleOpen(isOpen), [isOpen]);
  const _click = e => {
    e.preventDefault();
    toggleOpen(!_open);
    return onClick(!_open);
  };
  return (
    <button
      type="button"
      onClick={_click}
      aria-label="Close button"
      aria-expanded={_open ? 'true' : 'false'}
      className={`${styles.btn} ${_open === true ? styles.btn_open : ''}`}
    >
      <span />
      <span />
      <span />
    </button>
  );
};

BtBurger.defaultProps = {
  onClick: () => true,
  isOpen: false,
};

export default BtBurger;
